showBurger();
function showBurger() {
  const burger = document.querySelector('.nav__burger');
  const menu = document.querySelector('.nav__menu');
  const body = document.querySelector('body');

  burger.addEventListener('click', () =>  {      
      menu.classList.toggle('active');
      burger.classList.toggle('active');
      body.classList.toggle('lock');      
  });
  document.querySelectorAll('.nav__link').forEach(item =>{
    item.addEventListener('click', () =>{
 
    burger.classList.remove('active');
    menu.classList.remove('active');
    body.classList.remove('lock');  
    });
  })
};

AOS.init({
  // Global settings:
  disable: 'phone',  // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  once: true,
})

showMore();
function showMore() {
  const btnMore = document.querySelector('.--btn-more');
  const gallery = document.querySelector('.gallery__wrap');
  gallery.classList.add('--hide-content');
  btnMore.addEventListener('click', () => {
      gallery.classList.remove('--hide-content');
      btnMore.remove();    
  })
}

scrollSmooth();
function scrollSmooth() {
  const anchors = document.querySelectorAll('.nav__link a');

  for (let anchor of anchors) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()
      
      const blockID = anchor.getAttribute('href').substr(1)
      
      document.getElementById(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    })
  }
  function removeClass() {
    let menuLinkActive = document.querySelector('.menu__link.--active');
  
    if(menuLinkActive) {
      menuLinkActive.classList.remove('--active');
    }
  }
}


